"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Builder = _interopRequireDefault(require("./Builder.js"));

var _Instruction = _interopRequireDefault(require("./Instruction.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/render/canvas/ImageBuilder
 */


var CanvasImageBuilder =
/** @class */
function (_super) {
  __extends(CanvasImageBuilder, _super);
  /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */


  function CanvasImageBuilder(tolerance, maxExtent, resolution, pixelRatio) {
    var _this = _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
    /**
     * @private
     * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
     */


    _this.hitDetectionImage_ = null;
    /**
     * @private
     * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
     */

    _this.image_ = null;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.imagePixelRatio_ = undefined;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.anchorX_ = undefined;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.anchorY_ = undefined;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.height_ = undefined;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.opacity_ = undefined;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.originX_ = undefined;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.originY_ = undefined;
    /**
     * @private
     * @type {boolean|undefined}
     */

    _this.rotateWithView_ = undefined;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.rotation_ = undefined;
    /**
     * @private
     * @type {import("../../size.js").Size|undefined}
     */

    _this.scale_ = undefined;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.width_ = undefined;
    /**
     * Data shared with a text builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */

    _this.declutterImageWithText_ = undefined;
    return _this;
  }
  /**
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */


  CanvasImageBuilder.prototype.drawPoint = function (pointGeometry, feature) {
    if (!this.image_) {
      return;
    }

    this.beginGeometry(pointGeometry, feature);
    var flatCoordinates = pointGeometry.getFlatCoordinates();
    var stride = pointGeometry.getStride();
    var myBegin = this.coordinates.length;
    var myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
    this.instructions.push([_Instruction["default"].DRAW_IMAGE, myBegin, myEnd, this.image_, // Remaining arguments to DRAW_IMAGE are in alphabetical order
    this.anchorX_ * this.imagePixelRatio_, this.anchorY_ * this.imagePixelRatio_, Math.ceil(this.height_ * this.imagePixelRatio_), this.opacity_, this.originX_, this.originY_, this.rotateWithView_, this.rotation_, [this.scale_[0] * this.pixelRatio / this.imagePixelRatio_, this.scale_[1] * this.pixelRatio / this.imagePixelRatio_], Math.ceil(this.width_ * this.imagePixelRatio_), this.declutterImageWithText_]);
    this.hitDetectionInstructions.push([_Instruction["default"].DRAW_IMAGE, myBegin, myEnd, this.hitDetectionImage_, // Remaining arguments to DRAW_IMAGE are in alphabetical order
    this.anchorX_, this.anchorY_, this.height_, this.opacity_, this.originX_, this.originY_, this.rotateWithView_, this.rotation_, this.scale_, this.width_, this.declutterImageWithText_]);
    this.endGeometry(feature);
  };
  /**
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */


  CanvasImageBuilder.prototype.drawMultiPoint = function (multiPointGeometry, feature) {
    if (!this.image_) {
      return;
    }

    this.beginGeometry(multiPointGeometry, feature);
    var flatCoordinates = multiPointGeometry.getFlatCoordinates();
    var stride = multiPointGeometry.getStride();
    var myBegin = this.coordinates.length;
    var myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
    this.instructions.push([_Instruction["default"].DRAW_IMAGE, myBegin, myEnd, this.image_, // Remaining arguments to DRAW_IMAGE are in alphabetical order
    this.anchorX_ * this.imagePixelRatio_, this.anchorY_ * this.imagePixelRatio_, Math.ceil(this.height_ * this.imagePixelRatio_), this.opacity_, this.originX_, this.originY_, this.rotateWithView_, this.rotation_, [this.scale_[0] * this.pixelRatio / this.imagePixelRatio_, this.scale_[1] * this.pixelRatio / this.imagePixelRatio_], Math.ceil(this.width_ * this.imagePixelRatio_), this.declutterImageWithText_]);
    this.hitDetectionInstructions.push([_Instruction["default"].DRAW_IMAGE, myBegin, myEnd, this.hitDetectionImage_, // Remaining arguments to DRAW_IMAGE are in alphabetical order
    this.anchorX_, this.anchorY_, this.height_, this.opacity_, this.originX_, this.originY_, this.rotateWithView_, this.rotation_, this.scale_, this.width_, this.declutterImageWithText_]);
    this.endGeometry(feature);
  };
  /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */


  CanvasImageBuilder.prototype.finish = function () {
    this.reverseHitDetectionInstructions(); // FIXME this doesn't really protect us against further calls to draw*Geometry

    this.anchorX_ = undefined;
    this.anchorY_ = undefined;
    this.hitDetectionImage_ = null;
    this.image_ = null;
    this.imagePixelRatio_ = undefined;
    this.height_ = undefined;
    this.scale_ = undefined;
    this.opacity_ = undefined;
    this.originX_ = undefined;
    this.originY_ = undefined;
    this.rotateWithView_ = undefined;
    this.rotation_ = undefined;
    this.width_ = undefined;
    return _super.prototype.finish.call(this);
  };
  /**
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @param {Object} [opt_sharedData] Shared data.
   */


  CanvasImageBuilder.prototype.setImageStyle = function (imageStyle, opt_sharedData) {
    var anchor = imageStyle.getAnchor();
    var size = imageStyle.getSize();
    var hitDetectionImage = imageStyle.getHitDetectionImage();
    var image = imageStyle.getImage(this.pixelRatio);
    var origin = imageStyle.getOrigin();
    this.imagePixelRatio_ = imageStyle.getPixelRatio(this.pixelRatio);
    this.anchorX_ = anchor[0];
    this.anchorY_ = anchor[1];
    this.hitDetectionImage_ = hitDetectionImage;
    this.image_ = image;
    this.height_ = size[1];
    this.opacity_ = imageStyle.getOpacity();
    this.originX_ = origin[0] * this.imagePixelRatio_;
    this.originY_ = origin[1] * this.imagePixelRatio_;
    this.rotateWithView_ = imageStyle.getRotateWithView();
    this.rotation_ = imageStyle.getRotation();
    this.scale_ = imageStyle.getScaleArray();
    this.width_ = size[0];
    this.declutterImageWithText_ = opt_sharedData;
  };

  return CanvasImageBuilder;
}(_Builder["default"]);

var _default = CanvasImageBuilder;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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